<template>
  <div
    style="
      background-color: white;
      width: 8.5in;
      min-height: 11in;
      margin: 0 auto;
      padding: 0.4in;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      box-sizing: border-box;
    "
  >
    <!-- Company Header -->
    <div style="display: flex; justify-content: space-between">
      <div>
        <h1 style="font-size: 18px; margin: 0; color: #2c3e50">
          {{ companySettings.name || 'Company Name' }}
        </h1>
        <p>
          {{ transaction.transaction_type === 'purchase' ? 'PURCHASE RECEIPT' : 'SALES RECEIPT' }}
        </p>
      </div>
      <div style="text-align: right; font-size: 9px; line-height: 1.2">
        <p v-if="companySettings.address" style="margin: 0 0 2px 0">{{ companySettings.address }}</p>
        <p v-if="companySettings.phone || companySettings.email" style="margin: 0 0 2px 0">
          <span v-if="companySettings.phone">Phone: {{ companySettings.phone }}</span>
          <span v-if="companySettings.phone && companySettings.email"> | </span>
          <span v-if="companySettings.email">Email: {{ companySettings.email }}</span>
        </p>
        <p v-if="companySettings.website" style="margin: 0 0 2px 0">{{ companySettings.website }}</p>
      </div>
    </div>

    <div
      style="
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 15px;
        padding: 8px 0;
        border-bottom: 1px solid #333;
        font-size: 10px;
      "
    >
      <span><strong>Transaction #:</strong> {{ transaction.transaction_number }}</span>
      <span style="display: none">|</span>
      <span><strong>Date:</strong> {{ formatDate(transaction.transaction_date) }}</span>
      <span style="display: none">|</span>
      <span><strong>Payment:</strong> {{ getPaymentMethodLabel(transaction.payment_method) }}</span>
      <span style="display: none">|</span>
      <span><strong>Status:</strong> {{ getPaymentStatusLabel(transaction.payment_status) }}</span>
    </div>

    <!-- Transaction Info Grid -->
    <div style="display: flex; justify-content: space-between; margin-bottom: 15px">
      <div
        style="width: 48%; border: 1px solid #ddd; padding: 8px; border-radius: 4px; font-size: 9px"
      >
        <div style="font-weight: bold; margin-bottom: 5px">
          {{ transaction.transaction_type === 'purchase' ? 'SUPPLIER' : 'CUSTOMER' }}
        </div>
        <div style="margin-bottom: 3px">{{ partyName }}</div>
        <div v-if="partyAddress" style="margin-bottom: 3px">{{ partyAddress }}</div>
        <div v-if="partyContact" style="margin-bottom: 3px">{{ partyContact }}</div>
      </div>
    </div>

    <!-- Transaction Items Table -->
    <div>
      <table style="width: 100%; border-collapse: collapse; font-size: 10px">
        <thead style="background-color: #f3f4f6">
          <tr>
            <th style="border: 1px solid #ddd; padding: 5px; text-align: left">Item</th>
            <th style="border: 1px solid #ddd; padding: 5px; text-align: right">Price per lb</th>
            <th style="border: 1px solid #ddd; padding: 5px; text-align: right">Gross Weight</th>
            <th style="border: 1px solid #ddd; padding: 5px; text-align: right">Tare Weight</th>
            <th style="border: 1px solid #ddd; padding: 5px; text-align: right">Net Weight</th>
            <th style="border: 1px solid #ddd; padding: 5px; text-align: right">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td style="border: 1px solid #ddd; padding: 5px; text-align: left">
              {{ item.commodity_name }}
            </td>
            <td style="border: 1px solid #ddd; padding: 5px; text-align: right">
              {{ formatCurrency(item.price_per_lb) }}
            </td>
            <td style="border: 1px solid #ddd; padding: 5px; text-align: right">
              {{ formatWeight(item.weight.gross ?? 0) }}
            </td>
            <td style="border: 1px solid #ddd; padding: 5px; text-align: right">
              {{ formatWeight(item.weight.tare ?? 0) }}
            </td>
            <td style="border: 1px solid #ddd; padding: 5px; text-align: right">
              {{ formatWeight(item.weight.net ?? 0) }}
            </td>
            <td style="border: 1px solid #ddd; padding: 5px; text-align: right">
              {{ formatCurrency(item.total_price) }}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="4" style="border: none"></td>
            <td style="border: 1px solid #ddd; padding: 5px; text-align: right; font-weight: bold">
              Total Weight:
            </td>
            <td style="border: 1px solid #ddd; padding: 5px; text-align: right">
              {{ formatWeight(calculateTotalWeight(props.items)) }}
            </td>
          </tr>
          <tr>
            <td colspan="4" style="border: none"></td>
            <td style="border: 1px solid #ddd; padding: 5px; text-align: right; font-weight: bold">
              Total Amount:
            </td>
            <td style="border: 1px solid #ddd; padding: 5px; text-align: right">
              {{ formatCurrency(transaction.total_amount) }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Notes Section -->
    <div v-if="transaction.notes" style="margin-top: 15px">
      <div style="font-weight: bold; margin-bottom: 5px">NOTES</div>
      <div>{{ transaction.notes }}</div>
    </div>

    <div
      v-if="transaction.transaction_type === 'purchase'"
      style="margin-top: 15px; font-size: 12px"
    >
      <div style="font-weight: bold; margin-bottom: 5px">LEGAL DECLARATION</div>
      <div style="font-size: 10px">
        I hereby affirm that I am the rightful owner of the hereon described merchandise; or I am an
        authorized representative of the rightful owner and affirm that I have been given authority
        by the rightful owner to sell the hereon described merchandise. I state under penalty of
        perjury under the laws of Oklahoma that the foregoing is true and correct.
      </div>
      <div style="margin-top: 5px">
        <strong>✓ Agreed by signer</strong>
      </div>
    </div>

    <!-- Signature Section -->
    <div style="margin-top: 15px; margin-bottom: 15px">
      <div style="display: flex">
        <div style="width: 100%">
          <div style="display: flex; align-items: center">
            <div style="font-size: 12px; margin-right: 1rem; width: 25%">
              {{ transaction.transaction_type === 'purchase' ? 'Supplier' : 'Customer' }} Signature:
            </div>
            <div v-if="transaction.party_signature" style="height: 24px; flex: 1">
              <img
                :src="transaction.party_signature.data_url"
                alt="Party Signature"
                style="height: 20px; max-width: 150px; object-fit: contain"
                width="150"
              />
            </div>
            <div v-else style="height: 24px; border-bottom: 1px solid #333; flex: 1"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div
      style="
        margin-top: 15px;
        text-align: center;
        font-size: 9px;
        border-top: 1px solid #ddd;
        padding-top: 8px;
      "
    >
      <p>Thank you for your business!</p>
      <p style="font-size: 8px; color: #777">
        This receipt was generated on {{ formatDateTime(new Date()) }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getPaymentMethodLabel, getPaymentStatusLabel } from '@/utils/labels'
import { formatDate, formatDateTime, formatCurrency, formatWeight } from '@/utils/formatters'
import { calculateTotalWeight } from '@/utils/transactionHelper'
import { useSettingsStore } from '@/stores/settings'
import type { TransactionRecord } from '@/types/Transaction'
import type { TransactionItem } from '@/types/Transaction'

const props = defineProps<{
  transaction: TransactionRecord
  items: TransactionItem[]
  partyData?: Record<string, unknown>
  partyName?: string
  partyAddress?: string
  partyContact?: string
}>()

const settingsStore = useSettingsStore()
const companySettings = computed(() => settingsStore.companySettings)
</script>
